/* eslint-disable no-unreachable */
import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { routeOptions } from './options';
import path from './path';
import authApi from '../apis/api/auth';
import jwtAuth from '../apis/utils/jwtAuth';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { reqPageClicked } from '../reduxs/home/action';

const redirectPath = '/holding';

export const Router = () => {
  // Presentation mode need user to click on the page once to enable autoplay feature
  // So we add a global on click event to show a modal asking user to click on the page
  const dispatch = useDispatch();
  useEffect(() => {
    document.onclick = function () {
      dispatch(reqPageClicked(true));
    }
  }, [])

  const authMiddleware = (routeRoles, history) => {
    if (routeRoles.length) {
      if (jwtAuth.checkToken()) {
        return getUserProfile(routeRoles, history);
      } else {
        return history.push(redirectPath, { path: window.location.pathname });
      }
    }
  };

  const getUserProfile = async (routeRoles, history) => {
    try {
      const res = await authApi.getMe();
      const userData = res?.data;
      if (routeRoles.length && !routeRoles.includes(userData?.userGroup?.name)) {
        return history.push(redirectPath);
      }
    } catch (error) {
      return history.push(redirectPath);
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        {routeOptions.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            render={(props) => (
              <item.component {...props} roles={item.roles} authMiddleware={authMiddleware} />
            )}
            exact={item.exact}
          />
        ))}
        <Route path="*">
          <Redirect to={path.NOTFOUND_PAGE} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
